<template>
    <span class="ah-el-select-bank">
        <el-select
            class="bank-select"
            ref="select"
            v-model="inputVal"
            style="min-width: 170px"
            filterable
            placeholder="銀行"
            :filter-method="filterMethod"
            no-data-text="無資料"
            no-match-text="無相關銀行"
            @focus="handleFocus"
            @change="handleBankChange"
            :disabled="disabled"
            :clearable="clearable"
            @keydown.native.capture.enter="handleKeyDownCapture"
        >
            <el-option v-for="item in optionsCopy" :key="item.boo" :label="item.nam" :value="item.boo" :class="'select-bank-boo-' + item.boo">
                <span style="float: left; color: #aaa; margin-right: 12px">{{ item.boo }}</span>
                <span style="float: left">{{ item.nam }}</span>
            </el-option>
        </el-select>
        <el-select
            class="branch-select"
            ref="branchSelect"
            v-model="branchVal"
            style="min-width: 260px"
            filterable
            placeholder="分行"
            :filter-method="filterMethodBranch"
            no-data-text="無資料"
            no-match-text="無相關分行"
            @focus="handleBranchFocus"
            @keydown.native.capture.enter="handleKeyDownCapture"
            :loading="isBranchLoading"
            loading-text="載入中..."
            :disabled="disabled || inputVal == null || inputVal === 0 || inputVal === ''"
            :clearable="clearable"
        >
            <el-option v-for="item in optionsBranchCopy" :key="item.doo" :label="item.nam" :value="item.doo" :class="'select-bank-doo-' + item.doo">
                <span style="float: left; color: #aaa; margin-right: 12px">{{ item.doo }}</span>
                <span style="float: left">{{ item.nam }}</span>
            </el-option>
        </el-select>
    </span>
</template>
<script>
export default {
    name: 'ah-el-select-bank',
    props: ['value', 'branch', 'disabled', 'clearable'],
    components: {},
    data() {
        return {
            options: [],
            optionsCopy: [],
            optionsBranch: [],
            optionsBranchCopy: [],
            isBranchLoading: false,
        };
    },
    computed: {
        inputVal: {
            get() {
                this.updateBranchList(this.value);
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        branchVal: {
            get() {
                return this.branch;
            },
            set(val) {
                this.$emit('branchInput', val);
            },
        },
    },
    watch: {
        inputVal(value) {
            this.updateBranchList(value);
        },
        branch(value) {
            console.log('branch changed: ', value);
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        // 取得下拉選單資料
        fetchData() {
            this.$api({
                url: '/Tool/GetBankOptions',
                method: 'GET',
            }).then((resp) => {
                // 列表資料
                this.options = resp.data.options;
                this.optionsCopy = this.options.filter(() => true);
            });
        },

        handleFocus() {
            this.optionsCopy = this.options.filter(() => true);
        },

        handleBranchFocus() {
            this.optionsBranchCopy = this.optionsBranch.filter(() => true);
        },

        handleBankChange() {
            this.branchVal = null;
            setTimeout(() => {
                this.$refs.branchSelect.focus();
            });
        },

        updateBranchList(boo) {
            if (boo) {
                this.isBranchLoading = true;
                this.$api({
                    url: `/Tool/GetBranchOptions?BOO=${boo}`,
                    method: 'GET',
                })
                    .then((resp) => {
                        // 列表資料
                        this.optionsBranch = resp.data.options;
                        this.optionsBranchCopy = this.optionsBranch.filter(() => true);
                    })
                    .finally(() => {
                        this.isBranchLoading = false;
                    });
            } else {
                this.optionsBranch = [];
                this.optionsBranchCopy = [];
            }
        },

        // 輸入時過濾方法
        filterMethod(val) {
            // 搜尋
            if (val) {
                this.optionsCopy = this.options.filter(
                    (item) =>
                        // 比對
                        item.nam.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.boo.toLowerCase().indexOf(val.toLowerCase()) > -1,
                );
            } else {
                this.optionsCopy = this.options.filter(() => true);
            }
        },

        // 輸入時過濾方法
        filterMethodBranch(val) {
            // 搜尋
            if (val) {
                this.optionsBranchCopy = this.optionsBranch.filter(
                    (item) =>
                        // 比對
                        item.nam.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.doo.toLowerCase().indexOf(val.toLowerCase()) > -1,
                );
            } else {
                this.optionsBranchCopy = this.optionsBranch.filter(() => true);
            }
        },
        handleKeyDownCapture(e) {
        // 判斷是否正在中文輸入法（IME）狀態
        // 1. e.isComposing 是現代瀏覽器標準
        // 2. e.keyCode === 229 是舊版處理 IME 的通用碼
            if (e.isComposing || e.keyCode === 229) {
                // 核心：停止傳播，讓 input 收不到這個 Enter 事件
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.ah-el-select-bank {
    .el-input > input {
        cursor: text;
    }

    .bank-select {
        .el-input > input {
            position: relative;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            &:focus {
                z-index: 1;
            }
        }
    }

    .branch-select {
        .el-input > input {
            position: relative;
            left: -2px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
</style>
